var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/games/icon-fish") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.2990455,16.3946006 C23.525122,16.3632732 22.9174611,15.7141582 22.939412,14.9422114 C22.9618918,14.1526539 23.6253556,13.5322115 24.4170867,13.560353 C25.1791973,13.5875212 25.8056355,14.2571672 25.7795412,15.0169016 C25.7523009,15.8114148 25.0910411,16.4267245 24.2990455,16.3946006 M20.9766136,20.7759278 C20.9766136,20.7759278 16.4620449,21.9922994 12.5010092,17.8994678 C11.8282009,17.2043351 10.8073518,16.0684945 11.1119315,15.14876 C11.2889493,14.6144238 11.9295806,13.5262823 12.3139417,13.0951318 C13.0614184,12.2563708 15.172143,9.29884891 20.9766136,9.53424712 C20.9766136,9.53424712 17.048372,15.3022113 20.9766136,20.7759278 M27.9609671,12.7707956 C26.5712723,10.6174329 24.7489949,8.91017637 22.5575192,7.59389327 C22.3730964,7.48309682 22.1862052,7.34716762 22.0562629,7.17946852 C21.1915384,6.06265443 20.1641657,5.11610582 19.0079086,4.32318552 C18.6951303,4.10867226 18.250294,4.01371652 17.862054,4.0021236 C17.2792532,3.98468997 16.6916919,4.07840678 16.1081858,4.143805 C13.9834444,4.38176959 11.9054258,4.81265452 9.93989448,5.69123853 C9.10108797,6.06628275 9.09015659,6.14575177 9.76684381,6.78247739 C10.6042398,7.57053044 11.3600913,8.42681357 11.998078,9.43230023 C10.9241588,10.5509727 9.87941931,11.6671673 8.80135679,12.7499991 C8.28343894,13.2701761 7.86928098,13.2257513 7.39411891,12.6466363 C7.10575988,12.2952204 6.87417347,11.8974328 6.60820613,11.5269019 C5.59705418,10.1177869 4.13718704,9.56176924 2.49466018,9.3569905 C2.13401305,9.31203475 1.94641659,9.47318518 2.01341533,9.83468958 C2.19519347,10.815132 2.31905297,11.8160169 2.61155534,12.7635389 C2.97916681,13.9540698 3.72532113,14.8974326 4.88713207,15.4481405 C4.90582119,15.4569901 4.90970007,15.4969901 4.91331447,15.5055742 C4.5831694,15.7315033 4.21864339,15.9140697 3.93777765,16.1843352 C2.42581017,17.6390253 2.06481041,19.5261934 2.02593351,21.5176092 C2.02417039,21.6091136 2.20815244,21.7522109 2.32927909,21.7861047 C2.47605922,21.8271667 2.65342955,21.8003525 2.80823189,21.7635383 C4.45719415,21.371149 5.91600342,20.6846004 6.80814446,19.1299102 C6.91049384,18.9515916 7.033031,18.7840695 7.15495106,18.6180518 C7.79866784,17.7421227 8.21238502,17.6733616 9.02783014,18.3722111 C9.89898999,19.1188482 10.7280993,19.9146889 11.5967026,20.6644234 C13.2629435,22.1025649 14.9714112,23.4749542 17.2843662,23.8657506 C16.9663867,24.8446001 16.5458815,25.7186708 15.8386041,26.4395557 C15.724001,26.5563699 15.6488037,26.7122991 15.5554463,26.8501752 C15.7269983,26.902653 15.9014595,27.0084052 16.0697497,26.9994672 C17.9904976,26.8974318 19.7169492,26.2734495 21.1823702,25.0002638 C21.8370183,24.4315028 22.3499113,23.7503524 22.58282,22.897963 C22.6594278,22.6175206 22.8074421,22.4550427 23.0569242,22.3177861 C24.88167,21.3138923 26.474036,20.0238039 27.7441909,18.3602642 C29.3539237,16.2520343 29.4051424,15.0084945 27.9609671,12.7707956",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.8%",
    y: "-8.7%",
    width: "129.6%",
    height: "134.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/games/icon-fish",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFish);
export default __webpack_public_path__ + "static/media/icon-fish.39dc9723eebec4d769989da307c7b159.svg";
export { ForwardRef as ReactComponent };